import { render, staticRenderFns } from "./UrlList.vue?vue&type=template&id=9350096e&"
import script from "./UrlList.vue?vue&type=script&lang=js&"
export * from "./UrlList.vue?vue&type=script&lang=js&"
import style0 from "./UrlList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports